import React from 'react'
import ProgressBar from '../progressBar/progressBar'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  className?: string
  comingSoon?: boolean
  loadingState?: boolean
  progressStyle?: React.CSSProperties | undefined
  index?: number
}

const Card = ({
  children,
  className,
  comingSoon,
  loadingState,
  progressStyle,
  index = 0,
  ...rest
}: CardProps) => {
  return (
    <div
      className={`relative ${index % 2 === 0 ? 'bg-primary' : 'bg-table-raw'} md:rounded-radius-md text-primary-foreground border border-secondary-border shadow-[0_4px_4px_rgba(129,129,129,0.25)] ${className}`}
      data-testid='card'
      {...rest}
    >
      <div
        className={`${comingSoon ? 'blur-[2px] cursor-not-allowed' : ''} relative h-full ${className?.includes('flex') ? (className.includes('flex-row') ? 'flex flex-row' : 'flex flex-col') : ''}`}
      >
        {children}
      </div>
      {comingSoon && (
        <div className='absolute inset-0 flex items-center justify-center z-10 ~text-sm/3xl text-info top-[25px] font-semibold'>
          Insufficient Data
        </div>
      )}
      {loadingState && progressStyle && (
        <ProgressBar progress={progressStyle} />
      )}
      {/* <ProgressBar progress={progressStyle} /> */}
    </div>
  )
}

export default Card
